const faqs = [
  {
    q: '夜猫电影院是免费的吗？需要注册吗？',
    a: '是的，夜猫电影院完全免费在线观看，无需注册登录即可畅享全部高清影视资源。我们致力于为夜猫子们提供零门槛的午夜观影体验，打开即看，没有任何隐藏收费。',
  },
  {
    q: '为什么叫"夜猫电影院"？和其他平台有什么不同？',
    a: '因为我们专为夜间追剧人群打造！每日凌晨 2:00 准时更新最新剧集和电影，配合分布式加速节点确保深夜高峰时段不缓冲不卡顿。不管你是熬夜党还是午夜观影爱好者，这里都是你的专属角落。',
  },
  {
    q: '手机上能看吗？画质怎么样？',
    a: '完全支持！手机、平板、电脑全端适配，躺床上用手机刷剧和坐桌前用电脑看大片体验一样流畅。所有影片默认为高清 1080P，部分热门影片提供 4K 超清选项，智能根据你的网络状况自适应画质。',
  },
  {
    q: '片库多久更新一次？能点播想看的片子吗？',
    a: '片库每日凌晨自动更新，热门连载剧集播出后第一时间上架。如果你有想看的电影或电视剧，可以通过联系我们页面的邮箱投稿建议，我们会根据需求热度优先安排上架计划。',
  },
];

export default function FAQSection() {
  return (
    <section id="faq" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-3">
            常见问题
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-md mx-auto">
            关于夜猫电影院你可能想了解的一切
          </p>
        </div>

        <div className="max-w-3xl mx-auto">
          <div className="space-y-3">
            {faqs.map((faq, i) => (
              <div
                key={i}
                className="bg-background-50 rounded-xl border border-background-200/70 overflow-hidden"
              >
                <div className="p-5 md:p-6">
                  <h3 className="font-heading text-sm md:text-base font-semibold text-foreground-900 mb-2 flex items-start gap-2">
                    <span className="text-primary-500 flex-shrink-0 mt-0.5">
                      <i className="ri-question-answer-line"></i>
                    </span>
                    {faq.q}
                  </h3>
                  <p className="text-sm text-foreground-600 leading-relaxed pl-6">
                    {faq.a}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}